import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paragraph from '../Paragraph/Paragraph';
import CheckIcon from '../Icons/CheckIcon';

const CheckItemStyles = styled.li`
  display: flex;

  > :first-child {
    margin: 0 0.5rem;
  }
`;

const CheckItem = ({ color, text, children, fontWeight = 400, variant }) => {
  if (text) {
    return (
      <CheckItemStyles>
        <CheckIcon />
        <Paragraph variant={variant} color={color} fontWeight={fontWeight}>
          {text}
        </Paragraph>
      </CheckItemStyles>
    );
  }

  if (children) {
    return (
      <CheckItemStyles>
        <CheckIcon /> {children}
      </CheckItemStyles>
    );
  }

  return null;
};

CheckItem.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  fontWeight: PropTypes.number,
  variant: PropTypes.string,
};

export default CheckItem;
